<template lang="pug">
  .panel-page
    .panel.mx-auto
      h1 Thank you for registering.
      h4 Your registration is PENDING.
      p.body-1
        | A confirmation email has been sent to
        strong  {{ primaryEmail }}
        | . Click on the verification link in the email to verify your email. You must confirm your email
        | address and an administrator must approve your account before you can sign-in to the application.
        h4
          router-link(to="/login") Return to Login Page
</template>

<script>
import { formItem } from '@/lib/formstore'

export default {
  name: 'RegistrationPending',
  data: function() {
    return {
      primaryEmail: formItem('registration', 'primaryEmail'),
    }
  },
}
</script>

<style lang="scss" scoped>
.page {
  background: #f8f8f8;
}
</style>
